import { render, staticRenderFns } from "./add-callout.vue?vue&type=template&id=60ad6e08&"
import script from "./add-callout.vue?vue&type=script&lang=js&"
export * from "./add-callout.vue?vue&type=script&lang=js&"
import style0 from "./add-callout.vue?vue&type=style&index=0&id=60ad6e08&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports